import { ChevronDown } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/flowly/infra/Button/Button";

interface ScrollToBottomButtonProps {
  isVisible: boolean;
  onClick: () => void;
  newMessagesCount?: number;
}

export const ScrollToBottomButton = ({ 
  isVisible, 
  onClick, 
  newMessagesCount = 0 
}: ScrollToBottomButtonProps) => {
  const { t } = useLanguage();

  if (!isVisible) return null;

  return (
    <Button
      variant="primary"
      size="sm"
      onClick={onClick}
      className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 shadow-lg animate-fade-in"
    >
      <ChevronDown className="w-4 h-4" />
      <span className="text-sm font-medium">
        {newMessagesCount > 0
          ? t.scrollButton.newMessages.replace("{count}", String(newMessagesCount))
          : t.scrollButton.backToBottom}
      </span>
    </Button>
  );
};
